import type { FC } from "react";
import { HeartIcon } from "@heroicons/react/24/outline";
import { Button } from "@/components/button";
import { HoverTooltip } from "@/components/practitioner-card/hover-tooltip";
import { cn } from "@/lib/cn";
import { routes } from "@/lib/routes";

type HeaderActionsProps = {
  /** Desktop is the row in the main bar; mobile is the panel revealed by the hamburger (§4.6). */
  variant: "desktop" | "mobile";
  className?: string;
};

/* Saved practitioners live in localStorage (features/saved-practitioners), hence "on this device". */
const SAVED_HINT =
  "Saved practitioners: tap the heart on any practitioner to shortlist them here. Saved on this device, no account needed.";

/** Saved + Practitioner Login + Donation — the only actions until the real nav (`Menu List`) ships. */
export const HeaderActions: FC<HeaderActionsProps> = ({ variant, className }) => {
  if (variant === "mobile") {
    return (
      <>
        <Button variant="tertiary" href={routes.savedPractitioners.url} icon={<HeartIcon className="size-24" aria-hidden />}>
          Saved practitioners
        </Button>
        <Button variant="secondary-white" size="m" href={routes.signIn.url} className="w-full">
          Practitioner Login
        </Button>
        <Button
          variant="primary-blue"
          size="m"
          href={routes.donation.url}
          target="_blank"
          rel="noreferrer"
          className="w-full"
        >
          Donation
        </Button>
      </>
    );
  }

  return (
    <div className={cn("hidden items-center gap-16 lg:flex", className)}>
      <HoverTooltip side="bottom" label={SAVED_HINT}>
        <Button
          variant="icon"
          size="s"
          href={routes.savedPractitioners.url}
          aria-label="Saved practitioners"
          icon={<HeartIcon className="size-32 text-neutral-black" aria-hidden />}
        />
      </HoverTooltip>
      <Button variant="secondary-white" size="l" href={routes.signIn.url}>
        Practitioner Login
      </Button>
      <Button variant="primary-blue" size="l" href={routes.donation.url} target="_blank" rel="noreferrer">
        Donation
      </Button>
    </div>
  );
};
